import {
  UnifiedBuyerRoutes,
  UnifiedSellerRoutes,
  BlockedRoutes,
  AuthRoutes,
} from "..";
import ApprovalRoutes from "../Sellers/ApprovalRoutes/ApprovalRoutes";
import RegistrationCompletionRoutes from "../RegistrationCompletionRoutes/RegistrationCompletionRoutes";
import { useAuth, useUser } from "../../context";

const RoutesHandler = () => {
  const { isAuthenticated } = useAuth();
  const {
    isBuy,
    isBlocked,
    isSeller,
    isPendingAdminApproval,
    isPendingRegistration,
  } = useUser();

  if (isPendingRegistration && isAuthenticated) {
    return <RegistrationCompletionRoutes />;
  }

  if (isBlocked && isAuthenticated) {
    return <BlockedRoutes />;
  }

  if (isBuy && isAuthenticated) {
    return <UnifiedBuyerRoutes />;
  }

  if (isSeller && isAuthenticated) {
    if (isPendingAdminApproval) return <ApprovalRoutes />;
    return <UnifiedSellerRoutes />;
  }

  return <AuthRoutes />;
};

export default RoutesHandler;
